export default __webpack_public_path__ + "static/media/Tier_1.a955df26.svg";